/* CP — remet le symbole euro apres le montant : €69,99 -> 69,99 €
   Correctif d'affichage. Le vrai reglage est dans Shopify :
   Parametres > General > Devise > Modifier le format. */
(function(){
  var RE=/€\s?(\d[\d\s  .,]*)/g;
  var SKIP={SCRIPT:1,STYLE:1,TEXTAREA:1,NOSCRIPT:1};

  function fixNode(t){
    var p=t.parentNode;
    if(!p || SKIP[p.tagName]) return;
    var v=t.nodeValue;
    if(v.indexOf('€')<0) return;
    var out=v.replace(RE,function(m,num){
      var tail='', n=num;
      while(n.length && /[\s  ]/.test(n.charAt(n.length-1))){ tail=n.charAt(n.length-1)+tail; n=n.slice(0,-1); }
      return n+' €'+tail;
    });
    if(out!==v) t.nodeValue=out;
  }

  function walk(root){
    if(!root) return;
    if(root.nodeType===3){ fixNode(root); return; }
    if(root.nodeType!==1) return;
    if(SKIP[root.tagName]) return;
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null,false), n, list=[];
    while((n=w.nextNode())) if(n.nodeValue.indexOf('€')>=0) list.push(n);
    for(var i=0;i<list.length;i++) fixNode(list[i]);
  }

  function run(){ walk(document.body); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();

  if(window.MutationObserver){
    new MutationObserver(function(ms){
      for(var i=0;i<ms.length;i++){
        var a=ms[i].addedNodes;
        for(var j=0;j<a.length;j++) walk(a[j]);
      }
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
})();
